import { render, staticRenderFns } from "./CalliaGiftBox.vue?vue&type=template&id=340dc934&scoped=true"
import script from "./CalliaGiftBox.vue?vue&type=script&lang=js"
export * from "./CalliaGiftBox.vue?vue&type=script&lang=js"
import style0 from "./CalliaGiftBox.vue?vue&type=style&index=0&id=340dc934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340dc934",
  null
  
)

export default component.exports